import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { AnagraficaFilterModalInstanceComponent } from './anagrafica-filter-modal-instance';

export const AnagraficaFilterModalInstanceModule: string = ng
    .module('archiSmall.userSettings.anagraficaFilterModalInstanceModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('anagraficaFilterModalInstanceComponent', AnagraficaFilterModalInstanceComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/anagrafica-filter-modal-instance/anagrafica-filter-modal-instance.module.ts